import styled from 'styled-components';
import { Drawer, Button, Divider } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-header {
    padding: 16px 16px 16px 24px; /* Reduce right padding for close button */
    border-bottom: none; /* Remove horizontal divider */
  }

  .ant-drawer-header-title {
    flex-direction: row-reverse;
    align-items: center;
    min-width: 0; /* Allow title to shrink */
  }

  .ant-drawer-title {
    flex: 1;
    min-width: 0; /* Allow title to shrink */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 16px; /* Space between title and close button */
    font-size: 16px;
    font-weight: 600;
    color: #262626;
  }

  .ant-drawer-close {
    flex-shrink: 0; /* Prevent close button from shrinking */
    margin: 0;
    width: auto;

    /* Hide default hover borders and effects */
    border: none !important;
    box-shadow: none !important;
    outline: none !important;

    &:hover,
    &:focus,
    &:active {
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
      background: transparent !important;
    }

    /* Style our custom button */
    button {
      border: none !important;
      box-shadow: none !important;

      &:hover {
        border: none !important;
        box-shadow: none !important;
      }
    }
  }

  .ant-drawer-body {
    padding: 0;
    height: 100%;
    overflow-y: auto;
    background: #fff;
  }

  .ant-menu-light {
    background: unset;
  }

  /* .ant-drawer-header {
    border-bottom: 1px solid #e8e8e8;
    padding: 16px 24px;
    background: #fafafa;
  } */

  .ant-drawer-footer {
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fafafa;
  }

  .ant-drawer-extra {
    display: flex;
    align-self: baseline;
    padding: 10px 0;
  }

  /* Ensure it appears above sensitivity drawer */
  z-index: 1002;
`;

export const ContentWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  .ant-select-arrow {
    color: unset;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const EmptyStateWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
  flex-direction: column;
`;

export const StyledCloseButton = styled(Button)`
  font-size: 14px;
  flex-shrink: 0;
  border: none;
  border-radius: 6px;
  padding: 4px 8px;

  &:hover {
    background-color: #f5f5f5 !important;
  }

  &:focus,
  &:active {
    background-color: transparent !important;
  }
`;

export const SelectGroupLabel = styled.div`
  font-size: 15px;
  line-height: 24px;
  font-weight: 400;
  font-style: italic;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const StyledInfoIcon = styled(InfoCircleOutlined)`
  font-size: 14px;
  margin-left: 6px;
  margin-right: 6px;
`;

export const StyledDivider = styled(Divider)`
  border-color: rgb(0 0 0 / 80%);
`;

export const InfoText = styled.div`
  font-size: 14px;
  color: #595959;
  padding-inline-start: 40px;
`;
